/**
 * The kind of item a client reports itself as reading. Must match `PresenceScope` on the server.
 * Only these two carry viewer tracking.
 */
export const PRESENCE_SCOPE = {
  documents: 'documents',
  tasks: 'tasks'
};
